export default function displayInfoContainer(text, showCancelButton, performFunction) {
    if (showCancelButton === void 0) { showCancelButton = false; }
    var domElements = document.querySelectorAll("header, main, footer");
    var infoContainer = document.getElementById("info-container");
    disableDomElements(domElements);
    showInfoContainer(infoContainer, text);
    var infoContainerOKButton = addOkButton();
    removeTrailingCancelButton(infoContainer);
    addCancelButton(infoContainerOKButton);
    /*
    Buttons Functions
    */
    function addOkButton() {
        var infoContainerOKButton = document.getElementById("info-container-ok-button");
        infoContainerOKButton.addEventListener("click", executeFunction);
        return infoContainerOKButton;
    }
    function addCancelButton(infoContainerOKButton) {
        if (showCancelButton) {
            var cancelButton = createCancelButton();
            infoContainerOKButton.after(cancelButton);
            cancelButton.addEventListener("click", function () {
                enableDomElements(domElements);
                hideInfoContainer(infoContainer);
                infoContainerOKButton.removeEventListener("click", executeFunction);
            });
        }
    }
    function executeFunction() {
        enableDomElements(domElements);
        hideInfoContainer(infoContainer);
        if (performFunction && showCancelButton) {
            performFunction();
            infoContainerOKButton.removeEventListener("click", executeFunction);
        }
    }
}
function disableDomElements(domElements) {
    domElements.forEach(function (element) {
        element.style.opacity = "0.4";
        element.style.pointerEvents = "none";
    });
}
function enableDomElements(domElements) {
    domElements.forEach(function (element) {
        element.removeAttribute("style");
    });
}
function showInfoContainer(infoContainer, text) {
    infoContainer.classList.add("display-info-container");
    var paragraph = document.getElementById("info-container-paragraph");
    paragraph.innerText = text;
}
function hideInfoContainer(infoContainer) {
    infoContainer.classList.remove("display-info-container");
}
function removeTrailingCancelButton(infoContainer) {
    var existsCancelButton = document.getElementById("info-container-cancel-button");
    if (existsCancelButton) {
        infoContainer.removeChild(existsCancelButton);
    }
}
function createCancelButton() {
    var cancelButton = document.createElement("button");
    cancelButton.innerHTML = "Cancelar";
    cancelButton.id = "info-container-cancel-button";
    return cancelButton;
}
